export class DashBoardCustomerOrderStatus {
  Pending = 0;
  Confirm = 1;
  Dispatched = 2;
  Delivered = 3;
}

export class DashBoardProduct {
  isActive: boolean;
}
export enum DashBoardOrderStatus
{
    Pending = 0,
    Confirm = 1,
    Dispatched = 2,
    Delivered = 3
}